function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadTask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "308.505 141.769 44.98 54.619",
    width: 44.98,
    height: 54.619,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M 308.505 196.388 L 353.485 196.388 L 353.485 189.962 L 308.505 189.962 L 308.505 196.388 Z M 353.485 161.046 L 340.634 161.046 L 340.634 141.769 L 321.357 141.769 L 321.357 161.046 L 308.505 161.046 L 330.995 183.536 L 353.485 161.046 Z",
    style: {},
    transform: "matrix(1, 0, 0, 1, 0, 3.552713678800501e-15)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadTask);
export default __webpack_public_path__ + "static/media/download-task.2aaef5d0.svg";
export { ForwardRef as ReactComponent };